<template>
  <div id="soventros" style="text-transform: capitalize;">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader || loader3 || loader4 ">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox" style="min-width:17%">
          <select @change="websiteChanged" v-model="selected_website" class="form-control text-uppercase">
            <optgroup label="Retail">
              <option value="https://www.flipkart.com">Flipkart</option>
            </optgroup>
          </select>
        </div>
        <div class="datebox">
          <select v-model="device" @change="refresh"  class="form-control text-uppercase">
            <option value="wheel_chairs">Wheel Chairs</option>
          </select>
        </div>  
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	
  	 	</div>
  	</div>
    <div class="container-fluid ">
      <div class="row " v-if="isOEM">
        <div :class="getClassSOVSOS()" v-for="(d,i) in websiteSOSGraphs" :key="d.key" >
          <div class="card" >
            <div style="margin:0" class="space-between-header">
              <p style="margin:0;padding-bottom:0!important" class="p-2">{{ d.title }}</p>
               <div v-if="sovShowDetailsSiteList.includes(selected_website) && i ==0" @click="goToSOVDetail" class="sovshowdetails badge badge-primary">Show Details</div>
            </div>
            <highcharts :options="d.chart" ></highcharts>
            </div>  
        </div>
      </div>      
      <div class="row " v-if="!isOEM">
          <div :class="showBrand ? 'col-sm-6': 'col-sm-6'" style="padding-right:2px">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV {{ deviceMapper[device] }} Category</p>
              </div>
              <highcharts :options="charts" v-if="activeChart" ></highcharts>
            </div>
          </div>
          <!-- <div class="col-md-4" style="padding-left:2px;padding-right:2px" v-if="showBrand">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV {{ deviceMapper[device] }} Search</p>
              </div>
              <highcharts :options="charts_sos" v-if="activeChart" ></highcharts>
            </div>
          </div> -->
          <div :class="showBrand ? 'col-sm-6': 'col-sm-6'" style="padding-left:2px">
            <div class="card" >
              <div style="margin:0" class="space-between-header">
                <p style="margin:0;padding-bottom:0!important" class="p-2">SOV Position on Page</p>
              </div>
              <highcharts   :options="categorySearchGraph" v-if="activecategorySearchGraph" ></highcharts>
            </div>
          </div>
      </div>    
     
      <div v-if="!isOEM">
        <div>
          <div class="space-between-header" >
            <h4 style="max-width:50%">{{ deviceMapper[device] }} Trends</h4>
            <div> 
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="sovInterval" name="radiosBtn">
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                </b-form-radio-group>
                <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
                <datepicker  placeholder="From" @input="sovDateChanged" v-model="sovStartDate" />
                <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
                <datepicker class="picker-left"   placeholder="To" @input="sovDateChanged" v-model="sovEndDate" />
              </b-button-toolbar>
            </div>
          </div> 
          <div class="space-between-header">
            <h4>SOV trend for {{ deviceMapper[device] }} category page 1</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;" :options="daywiseChartPage1" ></highcharts>
          </div>
          <div class="space-between-header">
            <h4>SOV trend for {{ deviceMapper[device] }} category pages (1-3)</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;" :options="daywiseChart" ></highcharts>
          </div>
          <div v-if="selected_website=='https://global.jd.com'">
            <!-- <div class="space-between-header">
              <h4>SOV trend for Gaming {{ deviceMapper[device] }} category pages (1-3)</h4>
            </div>  
            <div class="card p-2">
              <highcharts style="width:100%;" :options="daywiseChartGaming" ></highcharts>
            </div> -->
            <!-- <div class="space-between-header">
              <h4>Average SOV trend for {{ deviceMapper[device] }} category pages (1-3)</h4>
            </div>  
            <div class="card p-2">
              <highcharts style="width:100%;" :options="daywiseChartAverage" ></highcharts>
            </div> -->
          </div>
        </div>  
        <div>
          <div class="space-between-header">
            <h4>SOV Trend for Position On {{ deviceMapper[device] }} category page</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;" :options="daywisePositionChart" ></highcharts>
          </div>
        </div>  
        <div >
           <div class="space-between-header" >
            <h4 >Trend for Entros {{ deviceMapper[device] }} count</h4>
          </div>  
          <div class="card p-2">
            <highcharts style="width:100%;"  :options="daywiseAMDCount" ></highcharts>
          </div>
          <div v-if="selected_website=='https://global.jd.com'">
            <!-- <div class="space-between-header" >
              <h4 >Trend for AMD Gaming {{ deviceMapper[device] }} count</h4>
            </div>  
            <div class="card p-2">
              <highcharts style="width:100%;"  :options="daywiseAMDCountGaming" ></highcharts>
            </div> -->
            <!-- <div class="space-between-header" >
              <h4 >Average Trend for Timex {{ deviceMapper[device] }} count</h4>
            </div>  
            <div class="card p-2">
              <highcharts style="width:100%;"  :options="daywiseAMDCountAverage" ></highcharts>
            </div> -->
          </div>
        </div>  
      </div>  
      <div v-else>
        <div  class="space-between-header">
          <h4> Trend for AMD vs Intel  {{ deviceMapper[device] }}</h4>
          <div> 
            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="sovIntervalOEM" name="radiosBtn">
                <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              </b-form-radio-group>
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">From</button>
              <datepicker  placeholder="From" @input="getDailyDataOEM" v-model="sovStartDate" />
              <button style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">To</button>
              <datepicker class="picker-left"   placeholder="To" @input="getDailyDataOEM" v-model="sovEndDate" />
              <button v-if="selected_website == 'https://store.hp.com/us' " @click="exportTimeline" class="ui button" style="margin-left: 6px;height: 30px;border: none;background: #8a87e8;color: white;">Export</button>
            </b-button-toolbar>
          </div>
        </div>
        <div v-if="!daywiseChartOEM.length" class="alert alert-danger"> No Data </div>
        <div v-for="d in daywiseChartOEM" :key="d.title">
           <div class="space-between-header" >
            <h4>{{d.title}}</h4>
          </div> 
          <div class="card p-2" >
            <highcharts style="width:100%;" :options="d.chart"  ></highcharts>
          </div>
        </div>
      </div>  
     
      <div >
        <div class="space-between-header"> 
            <h3 >{{ deviceMapper[device] }} Category Data </h3>
              <div> 
                <span style="line-height: 31px;margin-right: 10px;}">Pages:</span>
                <select @change="readyPie" v-model="selectedPage" class="form-control text-uppercase">
                  <option value="1-3">1-3</option>
                  <option value="1">1</option>
                </select>
              </div>  
          </div> 
          <h4 v-if="!isOEM" style="display:inline-block">All Listing</h4>
          <div @click="goToDetailPage" class="sovdetails listing-custom badge badge-primary">Show Details</div>
          	
          <div v-if="!isOEM" class="card">
            <highcharts style="width:100%" v-if="activePie" :options="pieChartAMDTotal" ></highcharts>
            <span style="font-size: 13px;text-align: center;margin-top: -13px;z-index: 9;padding-bottom: 10px;">Total {{ deviceMapper[device] }}: {{ pieTotalAll }}</span>  
          </div>
          

      </div>  
      <div v-if="selectedWebComplianceScore != ''">  
        <div class="space-between-header"> 
          <h4 >Compliance Score </h4>
          <h5 style="line-height: 36px;margin-bottom:0;">
            {{ websitesUrls3[selected_website] }}: 
            <span style="color:rgb(53 104 250);">{{ selectedWebComplianceScore }}</span>
          </h5>
         
          <div @click="goToCompliance" class="sovdetails listing-custom badge badge-primary">Show Details</div>
       
        </div> 
        <div class="card p-2">
          <highcharts :options="comChart" v-if="activeComChart" ></highcharts> 
        </div>   
      </div>  
        <div v-if="!errorInProduct">
          <div class="space-between-header"> 
            <h3 ></h3>
            <div style="display:inherit" > 
              <div v-if="selected_website == 'https://www.bestbuy.com' || selected_website == 'https://www.amazon.com'" style="display: flex; cursor: pointer;margin-right: 4px;">
                <div  style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
                  <input v-model="sponCheck" style="float: left;margin-right: 6px; margin-top: 3px;" type="checkbox">
                  <span> Sponsored </span>
                </div>
              </div>
              <div @click="showProductModal"  style="display:flex;cursor:pointer" >
                <div style="padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">Products</div>
                <div style="background: white;padding-left: 14px;padding-right: 14px;">
                  <span style="margin-top: 7px;float: left;font-size: 12px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 201px;">{{ selectedProduct.key }}</span>
                  <i style="padding-top: 7px;font-size: 17px;margin-left: 12px;" class="fa fa-angle-down"></i>
                </div>
              </div>
            
              <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">From</div>
              <datepicker  placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
              <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">To</div>
              <datepicker v-model="reviewEndDate" class="picker-left"   placeholder="To" @input="refreshReview" />
              <div  @click="goToSenti" class="sovdetails listing-custom badge badge-primary">Show Reviews</div> 
              </div> 
          </div> 
          <div class="card p-2" style="margin-bottom:4px">
            <div class="space-between-header">
              <h4>Total Reviews: {{ totalReviewCount | format }}</h4>
              <div> 
                <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                  <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="revInterval" name="radiosBtn">
                    <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                    <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                    <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
              </div>
            </div>  
            <highcharts :options="reviewGraph" v-if="activeReviewGraph" ></highcharts>
            <div style="margin:15px"></div>
            <highcharts :options="creviewGraph" v-if="activeReviewGraph" ></highcharts>
          </div>  
          <div class="card p-2">
            <div class="space-between-header">
              <h4 > Avg. Rating: {{ ratingAvg }}</h4>
              <div style="display:flex"> 
                <b-button-toolbar  aria-label="Toolbar with buttons group">
                  <b-form-radio-group class="  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="revInterval" name="radiosBtn">
                    <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                    <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                    <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                
              </div>
              
            </div>  
            <highcharts :options="ratingGraph" v-if="activeRatingGraph" ></highcharts>
            <div style="margin:15px"></div>
            <highcharts :options="cratingGraph" v-if="activeReviewGraph" ></highcharts>
            <p style="text-align: center;font-size: 12px;text-transform: initial;">Cumulative Rating = Cumulative Sum of Ratings / Cumulative Sum of Reviews</p>
          </div>   
        </div>
  
    </div>  
    <b-modal size="lg" title="Select Product" v-model="isProductModal" >
      <b-row>
        <div class="col-md-12" >
          <div style="position:relative">
            <input style="border-radius: 0;padding: 6px;font-size: 11px;height: 30px;padding-left: 30px;" class="form-control" v-model="schProduct" type="text" placeholder="Search"/>
            <i style="position:absolute;left:0;top:0;padding: 8px;" class="fa fa-search"></i>
          </div>  
        </div>
      </b-row> 
   
      <div class="space-between-header" style="padding-top:20px">
        <h6 class="m-0" >Products:</h6>
      </div>       
      <div style="padding-top:0px;cursor:pointer;height: 300px;overflow-y: scroll;">
        <div :class="{'selectedProduct':selectedProduct.key=='all'}" class="eachProduct" @click="selectProductNow({key:'all'})" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" >All
        </div>
        <div :class="{'selectedProduct':selectedProduct.key==d.key}" v-if="checkSearchFilter(d.key) " class="eachProduct" @click="selectProductNow(d)" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" :key="d.key" v-for="d in productOptions" >
          <span>{{ d.key }}</span>
   
        </div>
         
      </div>
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'


export default {
  name: 'sov',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website: 'https://www.flipkart.com',
      date:{
        startDate: '2022-03-09'
      },
      websitesUrls: {
        "https://www.flipkart.com": "flipkart",
      },    
      websitesUrls3: {
        "https://www.flipkart.com": "Flipkart",
      },
     
      oem_websites:['https://www8.hp.com/jp#commercial','https://www.lenovo.com/jp#commercial','https://b2b.lenovo.com.cn#commercial','https://www.hpstore.cn#commercial','https://www.nec-lavie.jp','https://fmv.fccl.fujitsu.com','https://www.dell.com/ja-jp','https://www.dell.com/en-au','https://www.lenovo.com/au','https://br-store.acer.com','https://s.lenovo.com.cn','https://store.hp.com/FranceStore','https://store.hp.com/mx-es','https://www.lenovo.com/fr','https://www.insight.com/en-US','https://store.hp.com/FranceStore#commercial','https://www.lenovo.com/fr#commercial','https://www.cdw.com','https://www.lenovo.com/gb#commercial','https://store.hp.com/UKStore#commercial','https://www.lenovo.com/de#commercial','https://store.hp.com/GermanyStore#commercial','https://www8.hp.com/jp','https://store.hp.com/us#commercial','https://www.lenovo.com/us#commercial','https://store.hp.com/UKStore','https://store.hp.com/us','https://www.asus.com/fr','https://store.asus.com/us','https://www.dell.com/en-us','https://store.acer.com/en-us','https://www.lenovo.com/us','https://www.lenovo.com/gb','https://www.lenovo.com/de'],
      columns:[
        {label: 'Brand', field: 'brand', sortable: false},
        {label: 'Sub Brand', field: 'sub_brand', sortable: false},
        {label: 'Form Factor', field: 'form_factor', sortable: false},
        {label: 'Page 1 System Count', field: 'page_1_system_count'},
        {label: 'Page Count (page 1)', field: 'page_1_count'},
        {label: 'Page 1 SOV', field: 'page_1_sov'},

        {label: 'Pages 1-3 System Count', field: 'page_1_3_system_count'},
        {label: 'Pages Count (1-3)', field: 'page_1_3_count'},
        {label: 'Pages 1-3 SOV', field: 'page_1_3_sov'},

        {label: 'All Pages System Count', field: 'page_all_system_count',},
        {label: 'All Pages Count', field: 'page_all_count'},
        {label: 'All Pages SOV', field: 'page_all_sov'},
      ],
      rows:[],
      sos_rows:[],
      rows_details:[],
      page:1,
      charts: {},
      charts_sos:{},
      activeChart: false,
      labelMapper: {
        'brand': 'Brand',
        'processor_type': 'Processor',
        // 'gpu_type': 'GPU'
      },
      isProductModal : false,
      countAMD: {},
      pieChartAMD: {},
      barGraph: {},
      activePie: false,
      activeBarChart: false,
      selectedPage: '1',
      loader: true,
      pageDistributionData: {},
      sovSOSGraph: {},
      activesovSOSGraph: true,
      categorySearchGraph: {},
      activecategorySearchGraph: true,
      colorShades: {
        red: [
          "#f56464","#fb7878","#fb9178","#fbc778","#f57264","#f56485","#f56492",
        ],
        blue: [
          "#7887fb", "#788dfb","#78a6fb", "#78b2fb","#78d0fb","#78d6fb","#78c4fb"
        ],
        green: [
          "#9af575","#87d866","#80f564","#9bf564","#64f591","#64f570","#71b755",
        ]
      },
      index:{
        red: 0,
        blue: 0,
        green: 0 
      },
      daywiseChart: {},
      daywiseChartPage1: {},
      dailyData: [],
      daywiseChartOEM: {},

      amdCPUFilter: 'all' ,
      pieTotal: '',
      pieTotalAll: '',
      comChart: {},
      activeComChart: false,
      selectedProduct: {},
      productOptions: [],
      productOptionsFull: [],
      reviewStartDate: '2021-12-01',
      reviewEndDate: '2022-03-09',
      reviewGraph: {},
      creviewGraph: {},
      activeReviewGraph: false,
      ratingGraph: {},
      cratingGraph:{},
      activeRatingGraph: false,
      totalReviewCount: '',
      ratingAvg: '',
      reviewStarData: {},
      sentimentData: {},
      sentimentChart: {},
      showBrand:true,
      showBrandHP: true,
      isOEM: false,
      activeSentimentChart: false,
      sovInterval: 'day',
      sovIntervalOEM: 'day',
      sovStartDate: '2022-03-04',
      sovEndDate: '2022-03-09',
      revInterval: 'day',
      selectedWebComplianceScore: '',
      brand_list:[],
      gpu_list:[],
      schProduct: '',
      deviceMapper:{
        'wheel_chairs': 'Wheel Chairs',
      },
      device: 'wheel_chairs',
      cpuFilter: '',
      brandFilter: '',
      filterKeys: {
        brand: [],
        processor_type: []
      },
      websiteSOSGraphs: [],
      errorInProduct: false,
      loader4: false,
      daywisePositionChart: {},
      daywiseAMDCount: {},
      sponCheck: false,
      ratingInput1: '',
      ratingExp: 'eq',
      ratingInput2: '',
      pickProduct: false,
     
      sovShowDetailsSiteList: [
        'https://store.hp.com/UKStore',
        'https://www.lenovo.com/fr',
      ],
      pieSeriesData: [],
      commercialSites: ['https://www8.hp.com/jp#commercial','https://www.lenovo.com/jp#commercial','https://b2b.lenovo.com.cn#commercial','https://www.hpstore.cn#commercial','https://www.insight.com/en-US','https://store.hp.com/FranceStore#commercial','https://www.lenovo.com/fr#commercial','https://www.cdw.com','https://www.lenovo.com/gb#commercial','https://store.hp.com/UKStore#commercial','https://www.lenovo.com/us#commercial','https://www.lenovo.com/de#commercial','https://store.hp.com/GermanyStore#commercial','https://store.hp.com/us#commercial'],
      fourKSeries: false, 
      fiveKSeries: false, 
      dailyDataPage1: [],
      dailyDataGamingPage13: [],
      dailyDataAveragePage13: [],
      daywiseAMDCountAverage: {},
      daywiseAMDCountGaming: {},
      daywiseChartAverage: {},
      daywiseChartGaming: {}
    }
  },
  watch:
  {
    'sponCheck':function(){
      this.getReviews()
    },
    'sovInterval':function(){
      this.getDailyData()
    },
    'sovIntervalOEM':function(){
      let self = this
      setTimeout(function(){
        self.getDailyDataOEM()
      })
    },
    'revInterval':function(){
      if(this.selectedProduct.key)
        this.getReviews()
    }
  },
  mounted()
  {
    if (localStorage.startDate) this.date.startDate = localStorage.startDate
    if (localStorage.selected_website) this.selected_website = localStorage.selected_website
    if(localStorage.cpuFilter) this.cpuFilter = localStorage.cpuFilter
    if(localStorage.brandFilter) this.brandFilter = localStorage.brandFilter
    if(localStorage.ratingExp) this.ratingExp = localStorage.ratingExp
    if(localStorage.ratingInput1) this.ratingInput1 = localStorage.ratingInput1
    if(localStorage.ratingInput2) this.ratingInput2 = localStorage.ratingInput2
    if(localStorage.fourKSeries) this.fourKSeries = JSON.parse(localStorage.fourKSeries)
    if(localStorage.fiveKSeries) this.fiveKSeries = JSON.parse(localStorage.fiveKSeries)
       
    if(localStorage.reviewStartDate)
    {
      this.reviewStartDate = localStorage.reviewStartDate
      this.reviewEndDate = localStorage.reviewEndDate
    }

    if(localStorage.sovStartDate)
    {
      this.sovStartDate = localStorage.sovStartDate
      this.sovEndDate = localStorage.sovEndDate
    }

    if(this.oem_websites.includes(this.selected_website))
    {
      this.showBrand = false
      this.showBrandHP = false
      this.isOEM = true
      this.labelMapper = {
        'processor_type': 'AMD Processor',
      }
    }
    else if(this.selected_website=="https://www.currys.co.uk")
    {
      this.showBrand = false
      this.isOEM = false
    }
    else if(this.selected_website=="https://www.harveynorman.com.au")
    {
      this.isOEM = false
      if(this.device=="desktop") this.showBrand = false
      else this.showBrand = true 
    }
    else
    {
      this.isOEM = false
      this.showBrand = true
      this.showBrandHP = true
      this.labelMapper = {
        'brand': 'AMD Brand',
        'processor_type': 'AMD Processor',
        // 'gpu_type': 'GPU'
      }
    }
   
    if(this.oem_websites.includes(this.selected_website))
      this.getWebsiteSOS()
    this.sov()
    this.website_details()
    this.ryzenVsNonRyzen()
    this.getDailyData()
    this.getDailyDataOEM()
    this.getComData()
    this.getProducts()
    
    if(this.selected_website != 'all')
      localStorage.selected_website = this.selected_website
    localStorage.selected_category = this.device
  },
  methods: {
    sovDateChanged(){
      localStorage.sovStartDate = moment(this.sovStartDate).format('YYYY-MM-DD')
      localStorage.sovEndDate = moment(this.sovEndDate).format('YYYY-MM-DD')
      this.getDailyData()
    }, 
  
    exportTimeline(){
      let self = this
      let payload = {
        'interval': this.sovIntervalOEM,
        'data': []
      }
      let cat =  this.daywiseChartOEM[0].chart.xAxis.categories
      for (let [idx, dataset] of this.daywiseChartOEM.entries()) 
      {
        let obj = {}
        obj.title = dataset.title.trim()
        obj.timeline = []
        for (let [idx2, dataset2] of cat.entries())  
        {
          let obj2 = {}
          obj2.date = dataset2
          for (let [idx3, dataset3] of dataset.chart.series.entries()) 
          {
             if(dataset3.name.includes('AMD'))
             {
               obj2['amd_count'] = dataset3.data[idx2].count
               obj2['total'] = dataset3.data[idx2].total
             }
             else
             {
               obj2['intel_count'] = dataset3.data[idx2].count
               obj2['total'] = dataset3.data[idx2].total
             }
          } 
          obj.timeline.push(obj2)
        }
        payload.data.push(obj)
      }
      const url = "/api/sov/export_data_excel"
      self.$http.post(url, payload ).then(response => {
        window.location = response.data.data
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    goToSOVDetail(){
      window.location =  "#/sovdetailed"

    },
    websiteChanged(){
      this.device = 'men_watches'
      this.refresh()
    },
    getClassSOVSOS(){
      if(this.websiteSOSGraphs.length == 1) return 'col-md-12'
      if(this.websiteSOSGraphs.length == 2) return 'col-md-6 mycols'
      if(this.websiteSOSGraphs.length == 3) return 'col-md-4 mycols'
      if(this.websiteSOSGraphs.length >= 4) return 'col-md-4 mycols'
    },
    
  
    removeRatingFilter(){
      this.ratingInput1 = ''
      this.ratingInput2 = ''
      if(localStorage.ratingExp) delete localStorage.ratingExp
      if(localStorage.ratingInput1) delete localStorage.ratingInput1
      if(localStorage.ratingInput2) delete localStorage.ratingInput2
      this.changeFilter()
    },
    applyRatingFilter(){
      let self = this
      if(self.ratingInput1 > 5 )
      {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if(self.ratingInput1 < 0 )
      {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if(self.ratingExp =='between')
      {
        if(self.ratingInput2 > 5  )
        {
          alert('Rating value should be between 0 and 5')
          return false
        }
        if(self.ratingInput2 < 0  )
        {
          alert('Rating value should be between 0 and 5')
          return false
        }
      }
      self.changeFilter()
    },
    orderAxis(uo_xaxis){
      let keylist = ['brand','consumer','commercial']
      let arr = []
      for (let [k, v] of keylist.entries())
      {
        for(let [idx, dataset] of uo_xaxis.sort().entries()) 
        {
          if(dataset.indexOf(v)!=-1)
          {
            arr.push(dataset)
          }
        }
      }
      return arr
    },
    drawWebSOSGraphs(d)
    {
      let self = this
      let max = 0
      for (let [so_i, so_d] of ['sov_data','sos_data'].entries())
      {
        for (let [eachSo_i, eachSo_d] of d[so_d].entries())
        {
          let sovsosobj = {}
          sovsosobj.title = 'AMD Vs Intel ' + self.deviceMapper[self.device] + ' ' + eachSo_d.label.toUpperCase() 
          let uo_xaxis = []
          let o_xaxis = []
          let data = []
          let obj = {}
          let max = 0
          let total = ''
          for (let [idx, dataset] of eachSo_d.data.entries())
          {
            let name = dataset.processor.replace('amd','AMD') + ' ' + dataset.segment
            uo_xaxis.push(name)
            let val = Math.round(dataset.sov)
            obj[name] = val
            if(dataset.sov > max) max = dataset.sov + 5 
            if(dataset.segment == 'consumer') total = dataset.total_count
            if(dataset.segment == 'commercial') total = dataset.total_count
          }
          o_xaxis = self.orderAxis(uo_xaxis)
          for (let [idx, dataset] of o_xaxis.entries())
          {
            data.push(obj[dataset])
          }
          sovsosobj.chart = 
          {
            credits: {
              enabled: false
            },
            chart: {
              type:'column',
              height:320,
              inverted:true
            },
            title: {
              text: ''
            },
            subtitle: {
                align:'left',
                text: 'Total ' + self.deviceMapper[self.device] + ': ' + total
            },

            yAxis: {
                title: {
                    text: ''
                },
                max: max,
                tickInterval: 5,
            },
              plotOptions: {
              column: {
                  dataLabels: {
                      enabled: true,
                      color:'black',
                      
                      formatter:function(){
                          return this.point.y + '%' 
                      }
                  }
              }
            },
            xAxis:{
              categories: o_xaxis,
              crosshair: true,
            },
            legend:{enabled:false},
            tooltip: {
              formatter: function() {
                var mytooltip = this.points[0].key  ;
                for(var i = 0;i<this.points.length;i++)
                {
                  mytooltip += this.points[i].series.name
                  mytooltip += ':<b> ' + self.format(this.points[i].y) + '%'; 
                }
                return mytooltip;
              },
              shared: true
            },
            series: [ 
            {
              name:'',
              data:data,
              color:'#3368fa8c',
            }]
          }
          self.websiteSOSGraphs.push(sovsosobj) 

        } 
        
      }  
    },
    getWebsiteSOS(){
      let self = this
      self.loader = true
      self.websiteSOSGraphs = []
      let payload = {
        "website": [this.selected_website],
        // "website": ['https://store.hp.com/us#commercial'],
        "item_category":self.device,
        "timestamp": self.date.startDate
        // "timestamp": moment().format('YYYY-MM-DD')
      } 
      const url = "/api/websites/website_sos"
      self.$http.post(url, payload ).then(response => {
        self.drawWebSOSGraphs(response.body)
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    checkChannel(){   
      if((this.selected_website == 'https://www.amazon.com') || (this.selected_website == 'https://www.harveynorman.com.au') || (this.selected_website == 'https://www.costco.com') || (this.selected_website == 'https://www.walmart.com') || (this.selected_website == 'https://global.jd.com') || (this.selected_website == 'https://www.bestbuy.com') || (this.selected_website == 'https://www.currys.co.uk') || (this.selected_website == 'https://www.mediamarkt.de'))
        {
          return true
        }
        else
        {
          return false
        }
    },
    changeFilter(){
      this.pickProduct = false
      this.selectedProduct = {key:'all'}
      localStorage.selected_product = JSON.stringify(this.selectedProduct)
      if(this.cpuFilter) localStorage.cpuFilter = this.cpuFilter 
      else delete localStorage.cpuFilter 
      if(this.brandFilter) localStorage.brandFilter = this.brandFilter 
      else delete localStorage.brandFilter
      if(this.ratingExp) localStorage.ratingExp = this.ratingExp
      else delete localStorage.ratingExp
      if(this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1 
      else delete localStorage.ratingInput1
      if(this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2
      else delete localStorage.ratingInput2
      if(this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries) 
      else delete localStorage.fourKSeries 
      if(this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries) 
      else delete localStorage.fiveKSeries 
      this.filterActions()
    },
    filterActions(){
      this.productOptions = []
      let brandCheck = true
      let cpuCheck = true
      let ratingCheck = true
      let seriesCheck = true
      
      let ratingExpMapper= {
          'eq': function(a,b){ return a==b},
          'gt': function(a,b){ return b>a},
          'gte': function(a,b){ return b>=a},
          'lt': function(a,b){ return b<a},
          'lte': function(a,b){ return b<=a},
          'between': function(a1,a2,b){ return ((b>=a1)&&(b<=a2))}
      } 
      for (let [ii, rr] of this.productOptionsFull.entries())
      {
        if(this.brandFilter)
          brandCheck = this.brandFilter == rr.brand_name
        if(this.cpuFilter)
          cpuCheck = this.cpuFilter == rr.processor_type
        if(this.ratingExp != 'between' && this.ratingInput1 )
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1,rr.rating)
        else if(this.ratingExp == 'between' && this.ratingInput1 && this.ratingInput1 )
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1,this.ratingInput2,rr.rating)
        
        if(this.fourKSeries && this.fiveKSeries )
          seriesCheck = (rr.processor_model[0] == '4') || (rr.processor_model[0] == '5')
        else if(this.fourKSeries && !this.fiveKSeries )
          seriesCheck = (rr.processor_model[0] == '4') 
        else if(!this.fourKSeries && this.fiveKSeries ) 
           seriesCheck = (rr.processor_model[0] == '5')   
        if(brandCheck && cpuCheck && ratingCheck && seriesCheck )
        {
          this.productOptions.push(rr)
        }
      }
      this.refreshReview()
    },
    checkSearchFilter(d){
      let self = this
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase())!=-1)
      {
        return true
      }
      else
      {
        return false
      }
    },
    selectProductNow(d){
      let self = this
      self.pickProduct = true
      self.selectedProduct = d
      localStorage.selected_product = JSON.stringify(self.selectedProduct)
      self.refreshReview()
      self.isProductModal = false
    },
    showProductModal(){
      let self = this
      self.isProductModal = true
    },
   
    goToCompliance(){
      let self = this
      localStorage.selectedWebComplianceScore = self.selectedWebComplianceScore
      window.location =  "#/compliance-detail"
    },
    formatDate(key,d){
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key]=='week')
      {
        let end_date = moment(d).add(6,'days')
        let today = moment(self.date.startDate)
        if(end_date >= today)
          end_date = today

        let weekStart = moment(d).format('MMM DD, YY')
        let weekEnd = moment(end_date).format('MMM DD, YY')

        if(moment(d) < moment(this.sovStartDate)) 
           weekStart =  moment(this.sovStartDate).format('MMM DD, YY')

        if(moment(end_date) > moment(this.sovEndDate))
          weekEnd = moment(this.sovEndDate).format('MMM DD, YY')

        obj['week'] =  weekStart + " - " +  weekEnd
      }
      return obj[this[key]]
    },
    drawReviewGraph(reviewData){
      let self = this
      self.totalReviewCount = reviewData.count
      let revRat = [
        { label:'Review', key:'review_count', graph:'reviewGraph', active:'activeReviewGraph' },
        { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' },
        { label:'cumulative Review', key:'commulative_review_count', graph:'creviewGraph', active:'activeReviewGraph' },
        { label:'cumulative Rating', key:'commulative_rating', graph:'cratingGraph', active:'activeReviewGraph' },
        // { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' }
      ]
      self.ratingAvg = reviewData.timeline[reviewData.timeline.length-1].commulative_rating.toFixed(1)
      let y_labels = ['Review Count','Avg. Rating','Cumulative Review Count','Cumulative Rating']
      let tick_arr = [50,1]
      let max_arr = [undefined,5]
      for (let [ii, rr] of revRat.entries())
      {
        let cat = []
        let data = []
        for(let [idx, dataset] of reviewData.timeline.entries()) 
        {
          cat.push(self.formatDate('revInterval',dataset.date))
          data.push(dataset[rr.key])
        }
        self[rr.graph] = {
          chart: {
              type: 'line',
              height:180
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          xAxis: {
              categories: cat,
              title: {
                  text: null
              }
          },
          plotOptions: {
              line: {
                  // dataLabels: {
                  //     enabled: true,
                  //     style:{fontWeight:0},
                  //     formatter:function(){
                        
                  //       let d = this.series.userOptions.detail[this.point.index]
                      
                  //       return this.point.y + '% (' + d + ')'
                  //     },
                  // }
              }
          },
          yAxis: {
              min: 0,
              tickInterval:tick_arr[ii],
              max:max_arr[ii],
              title: {
                  text: y_labels[ii],
        
              },
          },
          tooltip: {
            formatter: function() {
                  var mytooltip = this.key + '<br/>';
                  
                  mytooltip += '<span style="color:' + this.series.color + '">\u25CF</span> '
                    mytooltip += this.series.name
                    mytooltip += ' : <b> ' + self.format(this.y);

                    mytooltip += '</b><br/>'
                  
                  return mytooltip;
                },
          },
        
          legend: {
              enabled:false
          },
          credits: {
              enabled: false
          },
          series: [{
              name: rr.label,
              data: data,
              color: '#ffa500a8',
          }]
        }
        if(rr.graph=='ratingGraph')
          self['ratingGraph']['yAxis']['min'] = 1
        setTimeout(function(){
          self[rr.active] = true
        },200)
      }
    },
    getReviews(){
      let self = this
      self.loader = true
      self.activeReviewGraph = false
      let payload = {
        "start_date":moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date":moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "interval": self.revInterval,
        "client": "entros",
        "item_category": self.device,
      }
      if(self.sponCheck)
      {
        payload['sponsored'] =  self.sponCheck
      }
      if(self.brandFilter)
      {
        payload['brand'] = self.brandFilter
      }
      if(self.cpuFilter)
      {
        payload['processor'] = self.cpuFilter
      }

      if (self.selected_website != 'all')
      {
        payload["channel"] = self.websitesUrls[self.selected_website]
      }
      if ( self.selectedProduct.key != 'all')
      {
        payload["product_name"] = self.selectedProduct.key
      }
      if(self.ratingInput1 || self.fourKSeries || self.fiveKSeries)
      {
        if(self.pickProduct)
        {
          if(self.selectedProduct.key!='all')
            payload["product_name"] = self.selectedProduct.key
          else
          {
            payload["product_name"] = []
            for (let [ii, rr] of this.productOptions.entries())
            {
               payload["product_name"].push(rr.key)
            }
          }
        }
        else 
        {
          payload["product_name"] = []
          for (let [ii, rr] of this.productOptions.entries())
          {
            payload["product_name"].push(rr.key)
          }
        }  
      }
     
      const url = "/api/websites/review_histogram"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.drawReviewGraph(response.body.data)
      }, err => {
        self.loader = false
      });

    },
    refreshReview(){
      let self = this
      localStorage.reviewStartDate = moment(this.reviewStartDate).format('YYYY-MM-DD')
      localStorage.reviewEndDate = moment(this.reviewEndDate).format('YYYY-MM-DD')
      if(self.selectedProduct)
        self.getReviews()
    },
    getProducts(){
      let self = this
      self.loader = true
      self.productOptions = []
      self.selectedProduct = {}
      self.productOptionsFull = []
      const url = "/api/websites/website_products"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload['start_date'] = moment(self.reviewStartDate).format('YYYY-MM-DD')
      payload['end_date'] = moment(self.reviewEndDate).format('YYYY-MM-DD')
    
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx) 
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.errorInProduct = false
        if (!response.body.data.length)
        {
          self.drawReviewGraph({count:0,timeline:[]})
          self.errorInProduct = true
          return
        }
        // self.productOptions = response.body.data.sort()
        self.productOptionsFull = response.body.data
        self.filterKeys.brand = response.body.brand_list.sort()
        self.filterKeys.processor_type = response.body.processor_list.sort()
        
       if (localStorage.selected_product)
          self.selectedProduct = JSON.parse(localStorage.selected_product)
        else
        {
          self.selectedProduct = self.productOptionsFull[0]
          localStorage.selected_product = JSON.stringify(self.selectedProduct)
        }
        self.filterActions()
       
      }, err => {
        self.loader = false
        self.errorInProduct = true
      });
    },
    drawComChart(d){
      let self = this
     
      let categories = []
      let data1 = []
      let arr = []
      let highlight_color = ''
      let sumFinalScore = 0
      self.selectedWebComplianceScore = ''
      for(let [idx, dataset] of Object.entries(d)) 
      {
        if(self.selected_website == idx )
        {
          self.selectedWebComplianceScore = dataset.final_complaince_score
        }
        else if (self.selected_website == 'all')
        {
          sumFinalScore += dataset.final_complaince_score
        }
        arr.push({url:idx,data:dataset.final_complaince_score,total:dataset.total_count})
      }
      if (self.selected_website == 'all')
      {
        self.selectedWebComplianceScore = Number(sumFinalScore/Object.keys(d).length).toFixed()
      }
      
      let sortedArr =  arr.sort((a, b) =>  a.data - b.data);
      let newsortedArr = []
      for(let [idx, dataset] of sortedArr.entries())
      {
        if(self.oem_websites.includes(self.selected_website))
        {
          if(self.oem_websites.includes(dataset.url))
            newsortedArr.push(dataset)
        }
        else
        {
          if(!self.oem_websites.includes(dataset.url))
            newsortedArr.push(dataset)
        }
      }
      for(let [idx, dataset] of newsortedArr.entries())
      {
        if(newsortedArr.length == 1)
          categories.push(self.websitesUrls3[dataset.url])
        else
        {
          if(idx==0)
            categories.push(self.websitesUrls3[dataset.url]+'<br/> <b>(Least Compliant)</b>')
          else if(idx == newsortedArr.length-1)
            categories.push(self.websitesUrls3[dataset.url]+'<br/> <b>(Most Compliant)</b>')
          else
            categories.push(self.websitesUrls3[dataset.url])
        }
        if(self.selected_website == dataset.url)
          highlight_color = '#6a2798'
        else
          highlight_color = '#8a87e8'
        data1.push({'y':dataset.data,color:highlight_color})
      }
      let plotLine = []
      let midx = parseInt((data1.length)/2)
      if(self.isOEM)
      {
        plotLine.push({ color: 'black', width: 1, value: 85, dashStyle: 'shortdash', zIndex: 4, label: { text: 85 } }) //static lin at 85
      }
      else
      {
        plotLine.push({ color: 'black',width: 1,value: data1[midx].y,dashStyle: 'shortdash',zIndex: 4}) //dynamic line at data1[midx].y
      }
      self.comChart = {
            chart: {
            type: 'column',
            height:230,
            marginTop: 45
        },
        title: {
            text: ' '
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: 'Websites'
            }
        },
        plotOptions: {
            column: {
              dataLabels: {
                  enabled: true,
                  style:{fontWeight:0},
                  formatter:function(){
                    return this.point.y   
                  },
              }
            }
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: 'Compliance Score',
      
            },
            plotLines: plotLine,
        },
        tooltip: {
          shared:true,
          enabled: false
        },
      
        legend: {
            enabled:false
        },
        credits: {
            enabled: false
        },
        series: [{
            name: '',
            data: data1,
            // color: '#8a87e8',
            pointWidth: 60,
            dataSorting: {
                enabled: true
            },
            
        }]
      }
      setTimeout(function(){
        self.activeComChart = true
      },0)
    },
    getComData(){
      let self = this
      self.loader = true
      self.activeComChart = false
      let payload = {}
      payload["timestamp"] = self.date.startDate
      payload["item_category"] = self.device
      let url = "/api/websites/compliance_score"
      if(self.isOEM)
      {
        url = "/api/websites/oem_compliance_score"
        if(self.commercialSites.includes(self.selected_website))
          url = "/api/websites/commercial_compliance_score"
      } 
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.drawComChart(response.body.data)
      }, err => {
        self.loader = false
      });
      
    },
    goToDetailPage(){
      window.location = "#/sov-detailed-entros"
    },
    goToSenti(){
      window.location = "#/reviewslist-entros"
    },
    drawDailyAMDCount(d){
      let self = this
      let categories = []
      let data = []
      let data2 = []
      let data3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        data.push(dataset.amd_count)
        data2.push(dataset.all_count)
        data3.push(dataset.sov)
      }
      self.daywiseAMDCount = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
       
        yAxis: [{
            min: 0,
            title: { text: 'Count' },
        },  
        {
            min: 0,
            title: { text: 'Entros SOS' },
            opposite: false
        }],
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y);
              if(this.points[i].series.name.indexOf('SOS')!=-1)
                mytooltip += '%'
              mytooltip += '</b><br/>'
            }
            return mytooltip;
          },
          shared: true
        },
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [{
          name: 'Entros ' + self.deviceMapper[self.device],
          data: data,
          zIndex:9,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'All '+ self.deviceMapper[self.device],
          data: data2,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'Entros SOS',
          data: data3,
          yAxis: 1,  
          type:'line',
          pointWidth: 1,
          color: '#fb7878', 
        }]
      }
    },
    drawDailyAMDCountGaming(d){
      let self = this
      let categories = []
      let data = []
      let data2 = []
      let data3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        data.push(dataset.amd_count)
        data2.push(dataset.all_count)
        data3.push(dataset.sov)
      }
      self.daywiseAMDCountGaming = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
       
        yAxis: [{
            min: 0,
            title: { text: 'Count' },
        },  
        {
            min: 0,
            title: { text: 'AMD SOS' },
            opposite: false
        }],
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y);
              if(this.points[i].series.name.indexOf('SOS')!=-1)
                mytooltip += '%'
              mytooltip += '</b><br/>'
            }
            return mytooltip;
          },
          shared: true
        },
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [{
          name: 'AMD ' + self.deviceMapper[self.device],
          data: data,
          zIndex:9,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'All '+ self.deviceMapper[self.device],
          data: data2,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'AMD SOS',
          data: data3,
          yAxis: 1,  
          type:'line',
          pointWidth: 1,
          color: '#fb7878', 
        }]
      }
    },
    drawDailyAMDCountAverage(d){
      let self = this
      let categories = []
      let data = []
      let data2 = []
      let data3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        data.push(dataset.amd_count)
        data2.push(dataset.all_count)
        data3.push(dataset.sov)
      }
      self.daywiseAMDCountAverage = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: ''
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
       
        yAxis: [{
            min: 0,
            title: { text: 'Count' },
        },  
        {
            min: 0,
            title: { text: 'AMD SOS' },
            opposite: false
        }],
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y);
              if(this.points[i].series.name.indexOf('SOS')!=-1)
                mytooltip += '%'
              mytooltip += '</b><br/>'
            }
            return mytooltip;
          },
          shared: true
        },
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [{
          name: 'AMD ' + self.deviceMapper[self.device],
          data: data,
          zIndex:9,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'All '+ self.deviceMapper[self.device],
          data: data2,
          type: 'bar',
          yAxis: 0,  
        },
        {
          name: 'AMD SOS',
          data: data3,
          yAxis: 1,  
          type:'line',
          pointWidth: 1,
          color: '#fb7878', 
        }]
      }
    },
    drawDailyPagePosition(d){
      let self = this
      let categories = []
      let dataPage1 = []
      let dataPage2 = []
      let dataPage3 = []
      let laptop_count = 0
      for(let [idx, dataset] of d.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        dataPage1.push(dataset.data[1])
        dataPage2.push(dataset.data[2])
        dataPage3.push(dataset.data[3])
      }
      let obj = {}
      self.daywisePositionChart = {      
        chart: {
            type: 'column',
            height: 320
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: categories
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
              text: ''
          },
      },        
        tooltip: {
           enabled: false,
    
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  zIndex:0,
                  formatter: function() {
                    
                    return  '<span style="color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +self.format(Number(this.point.percentage.toFixed())) + '% </span>'
                },
               }
            }
        },
        series: [{
            name: 'Page 1',
            data: dataPage1,
            color:'#00800080',
            borderWidth: 0,
        }, {
            name: 'Page 2',
            data: dataPage2,
            color:'#ffa5008a',
            borderWidth: 0,
        },{
            name: 'Page 3',
            data: dataPage3,
            color:'#ff00008a',
            borderWidth: 0,
        } ]
      }
    },
    drawDailyChartAveragePage13(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyDataAveragePage13.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(Number(dataset.amd_sov))
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChartAverage = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'AMD SOV',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        },{
            name: 'Ryzen SOV',
            data: data3,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail1
        }, {
            name: 'Non-Ryzen SOV',
            data: data4,
            color: 'grey',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail2
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChartGamingPage13(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyDataGamingPage13.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(Number(dataset.amd_sov))
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChartGaming = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'AMD SOV',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        },{
            name: 'Ryzen SOV',
            data: data3,
            color: '#ffa500a8',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail1
        }, {
            name: 'Non-Ryzen SOV',
            data: data4,
            color: 'grey',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail2
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChart(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyData.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(Number(dataset.amd_sov))
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChart = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'Entros',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChartPage1(){
      let self = this
      let categories = []
      let data3 = []
      let data4 = []
      let amdSov = []
      let detail1 = []
      let detail2 = []
      let detail3 = []
      let laptop_count = 0
      for(let [idx, dataset] of this.dailyDataPage1.entries()) 
      {  
        categories.push(self.formatDate('sovInterval',dataset.timestamp))
        laptop_count = dataset.page_count
        let ryzensov = Number(dataset.ryzen_sov)
        let nonryzensov = Number(dataset.non_ryzen_sov)
        data3.push(ryzensov)
        data4.push(nonryzensov)
        amdSov.push(Number(dataset.amd_sov))
        detail1.push(dataset.ryzen + '/' + dataset.page_count)
        detail2.push(dataset.non_ryzen + '/' + dataset.page_count)
        detail3.push((dataset.ryzen + dataset.non_ryzen) + '/' + dataset.page_count)
      }
      let obj = {}
      self.daywiseChartPage1 = {
            chart: {
            type: 'line',
            height:230
        },
        title: {
            text: ''
        },
        subtitle: {
            verticalAlign:'bottom',
            text: 'Total ' + self.deviceMapper[self.device]  + ': '+laptop_count
        },
        xAxis: {
            categories: categories,
            title: {
                text: null
            }
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true,
                     allowOverlap:true,
                    style:{fontWeight:0},
                    
                    formatter:function(){ 
                      let category = this.point.category
                      let plotY = this.point.plotY
                      if(obj.hasOwnProperty(category))
                        obj[category].push(plotY)
                      else
                      {
                        obj[category] = []
                          obj[category].push(plotY)
                      }  
                      let plotYPos = obj[category].indexOf(plotY)
                      let prvPlotY = obj[category][plotYPos-1]
                      if( plotYPos > 0)
                      {
                        if((plotY - prvPlotY < 9) && (plotY - prvPlotY > -9))
                        {
                          this.point.plotY = this.point.plotY + 9
                          obj[category][plotYPos] = this.point.plotY
                        }
                      }
                      let d = this.series.userOptions.detail[this.point.index]
                      return this.point.y + '%'
                    },
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
      
            },
        },
        tooltip: {
          shared:true
        },
      
        legend: {
            enabled:true
        },
        credits: {
            enabled: false
        },
        series: [
        {
            name: 'Entros',
            data: amdSov,
            color: '#fb7878',
            tooltip: {
                valueSuffix: ' %'
            },
            detail: detail3
        }]
      }
      // if(self.selected_website=="https://store.hp.com/us")
      //   self.daywiseChart.subtitle.text = ""
    },
    drawDailyChartOEM(d){
      let self = this
      let sovsosmapper = {
        'sov_data': 'SOV',
        'sos_data': 'SOS'
      }
      for (let [so_i, so_d] of ['sov_data','sos_data'].entries())
      {
        for (let [eachSo_i, eachSo_d] of d[so_d].entries())
        {
          let obj = {}
          let categories = []
          for(let [idx, dataset] of eachSo_d.trend.entries()) 
          {  
            categories.push(self.formatDate('sovIntervalOEM',dataset.timestamp))
            for(let [idx2, dataset2] of dataset.data.entries()) 
            {
              let name = dataset2.processor.replace('amd','AMD') + ' ' + dataset2.segment
              if(obj.hasOwnProperty(name))
              {
                obj[name].push( {y:Math.round(dataset2.sov),count:dataset2.count,total:dataset2.total_count} )
              }
              else
              {
                obj[name] = []
                obj[name].push( {y:Math.round(dataset2.sov),count:dataset2.count,total:dataset2.total_count} )
              }
            }
          }
          let keylist = ['brand','consumer','commercial']
          for (let [k, v] of keylist.entries())
          {
            let seriesData = []
            for(let [idx, dataset] of Object.entries(obj))
            {
              if(idx.indexOf(v)!=-1)
              {
                seriesData.push({name:idx,data:dataset,tooltip: {valueSuffix: '%'}})
              }
            }
            if(seriesData.length)
            {
                let sovsosobj = {}
                sovsosobj.title = eachSo_d.label.toUpperCase() + ' ' + v.toUpperCase() + ' ' +   sovsosmapper[so_d] 
                sovsosobj.chart = {
                  chart: {
                    type: 'line',
                    height:230
                  },
                  title: {
                    text: ''
                  },
                  subtitle: {
                    verticalAlign:'bottom',
                    text: ''
                  },
                  xAxis: {
                    categories: categories,
                    title: {
                      text: null
                    }
                  },
                  plotOptions: {
                      line: {
                          dataLabels: {
                              enabled: true,
                                allowOverlap:true,
                              style:{fontWeight:0},
                              formatter:function(){ 
                                return this.point.y + '%'
                              },
                          }
                      }
                  },
                  yAxis: {
                      min: 0,
                      title: {
                          text: '',
                
                      },
                  },
                  tooltip: {
                    shared:true
                  },
                
                  legend: {
                      enabled:true
                  },
                  credits: {
                      enabled: false
                  },
                  series: seriesData
                }
                self.daywiseChartOEM.push(sovsosobj)

            }
          
          }
        }  
      }
    },
    getDailyData(){
      let self = this
      self.loader4 = true
      self.daywiseAMDCount = {}
      const url = "/api/websites/daily_sov"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload["timestamp"]  = '2022-02-02'
  
      payload["interval"] = self.sovInterval
      payload["start_date"] = moment(this.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(this.sovEndDate).format('YYYY-MM-DD')
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        if(self.selected_website == 'https://global.jd.com')
        {
          self.dailyDataGamingPage13 = response.body.gaming_data
          self.dailyDataAveragePage13 = response.body.average_data
          self.drawDailyChartGamingPage13()
          self.drawDailyChartAveragePage13()
          self.drawDailyAMDCountGaming(response.body.gaming_all_data)
          self.drawDailyAMDCountAverage(response.body.average_all_data)
        }
        self.dailyData = response.body.data
        self.dailyDataPage1 = response.body.page_1_data
        self.drawDailyChart()
        self.drawDailyChartPage1()
        self.drawDailyAMDCount(response.body.all_data)
        self.drawDailyPagePosition(response.body.page_data)
      }, err => {
        self.loader4 = false
      });
    },
    getDailyDataOEM(){
      let self = this
      self.loader4 = true
      const url = "/api/websites/website_sos_trend"
      self.daywiseChartOEM = []
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload["interval"] = self.sovIntervalOEM
      payload["start_date"] = moment(self.sovStartDate).format('YYYY-MM-DD')
      payload["end_date"] = moment(self.sovEndDate).format('YYYY-MM-DD')
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
        // payload["website"].push('https://store.hp.com/us#commercial')
      }
      self.$http.post(url, payload).then(response => {
        self.loader4 = false
        self.drawDailyChartOEM(response.body)
      }, err => {
        self.loader4 = false
      });
    },
    
    processCategorySearchGraph(){
      let self = this
      let cat = self.pageDistributionData.category
      let srch = self.pageDistributionData.search
      let catTotal =  cat[1] + cat[2] + cat[3] 
      let srchTotal =  srch[1] + srch[2] + srch[3] 

      self.categorySearchGraph = {      
        chart: {
            type: 'column',
            height: 320
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            opposite: true,
            categories: [ self.deviceMapper[self.device]  + ' category page']
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
              text: ''
          },
      },        
        tooltip: {
           enabled: false,
    
        },
        plotOptions: {
            column: {
                stacking: 'percent',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  zIndex:0,
                  formatter: function() {
                    
                    return  '<span style="color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +self.format(Number(this.point.percentage.toFixed())) + '% </span>'
                },
               }
            }
        },
        series: [{
            name: 'Page 1',
            data: [cat[1]],
            color:'#00800080',
            borderWidth: 0,
        }, {
            name: 'Page 2',
            data: [cat[2]],
            color:'#ffa5008a',
            borderWidth: 0,
        },{
            name: 'Page 3',
            data: [cat[3]],
            color:'#ff00008a',
            borderWidth: 0,
        } ]
      }
      // if(!this.showBrand)
      // {
      //   self.categorySearchGraph.xAxis.categories = [ self.deviceMapper[self.device]  + ' category page']
      //   self.categorySearchGraph.series = [{
      //       name: 'Page 1',
      //       data: [cat[1]],
      //       color:'#00800080',
      //       borderWidth: 0,
      //   }, {
      //       name: 'Page 2',
      //       data: [cat[2]],
      //       color:'#ffa5008a',
      //       borderWidth: 0,
      //   },{
      //       name: 'Page 3',
      //       data: [cat[3]],
      //       color:'#ff00008a',
      //       borderWidth: 0,
      //   } ]
      // }
    },
    processSOVSOSGraph(){
      let self = this
      let sov = {
        ryzen: ((self.pageDistributionData.sov.ryzen)/self.pageDistributionData.sov.total)*100,
        nonRyzen: ((self.pageDistributionData.sov.non_ryzen)/self.pageDistributionData.sov.total)*100,
      }
      let sos = {
        ryzen: ((self.pageDistributionData.sos.ryzen)/self.pageDistributionData.sos.total)*100,
        nonRyzen: ((self.pageDistributionData.sos.non_ryzen)/self.pageDistributionData.sos.total)*100,
      }
      sov.ryzen = Number(sov.ryzen.toFixed())
      sov.nonRyzen = Number(sov.nonRyzen.toFixed())
      sos.ryzen = Number(sos.ryzen.toFixed())
      sos.nonRyzen = Number(sos.nonRyzen.toFixed())
      let maxScale = sos.ryzen+sos.nonRyzen + 5
      if (sov.ryzen+sov.nonRyzen > sos.ryzen+sos.nonRyzen)
      {
        maxScale = sov.ryzen+sov.nonRyzen + 5
      }
      self.sovSOSGraph = {      
        chart: {
            type: 'column',
            height:320,
        },
        credits: {
          enabled: false
        },
        title: {
            text: ''
        },
        xAxis: {
            opposite: true,
            categories: [
              'All '+ self.deviceMapper[self.device]  +' Category Pages <br/> Total '+ self.deviceMapper[self.device]  +' = ' + self.pageDistributionData.sov.total,
              'All '+ self.deviceMapper[self.device]  +' Search Pages <br/> Total '+ self.deviceMapper[self.device]  +' = ' + self.pageDistributionData.sos.total
            ]
        },
        yAxis: { 
          min: 0,
          max: maxScale,
          title: {
              text: ''
          },
          stackLabels: {
            enabled:true,
            formatter:function(){
              let suf = ''
              let total = ''
              if (this.x==0)
              {
                suf = (self.pageDistributionData.sov.ryzen + self.pageDistributionData.sov.non_ryzen )
                total = self.pageDistributionData.sov.total
              }  
              else  
              { 
                suf = (self.pageDistributionData.sos.ryzen + self.pageDistributionData.sos.non_ryzen )
                total = self.pageDistributionData.sos.total
              }  
              return 'AMD:' + this.total + '%' 
            }
          }
      
      },        
        tooltip: {
           enabled:false,
          
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                  enabled: true,
                  useHTML: true,
                  formatter: function() {
                    let mapper = {}
                    let d = this.series.userOptions.myData[this.point.index]
                    
                    mapper['Ryzen SOV'] = d.ryzen + '/' + d.total
                    mapper['Non-Ryzen SOV'] = d.non_ryzen + '/' + d.total
                    
                    return  '<span style="color:white;font-size:11px;font-weight:normal;background-color:#00000085;padding:2px">' +self.format(this.point.y) + '%'
                },
               }
            }
        },
        series: [{
            name: 'Ryzen SOV',
            data: [sov.ryzen,sos.ryzen],
            color:'#ffa500a8',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov,self.pageDistributionData.sos]
        }, {
            name: 'Non-Ryzen SOV',
            data: [sov.nonRyzen,sos.nonRyzen],
            color:'grey',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov,self.pageDistributionData.sos]
         }
        ]
      }
      if(self.selected_website=="https://store.hp.com/us"  || self.selected_website=="https://store.asus.com/us")
      {
        self.sovSOSGraph.xAxis.categories = ['All '+ self.deviceMapper[self.device]  +' Category / Search Pages <br/> Total '+ self.deviceMapper[self.device]  +' = ' + self.pageDistributionData.sov.total]
        self.sovSOSGraph.series = [{
            name: 'Ryzen SOV',
            data: [sov.ryzen],
            color:'#ffa500a8',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov]
        }, {
            name: 'Non-Ryzen SOV',
            data: [sov.nonRyzen],
            color:'grey',
            borderWidth: 0,
            myData: [self.pageDistributionData.sov]
         }
        ]
      }

    },
    ryzenVsNonRyzen(){
      let self = this
      self.loader3 = true
      self.activecategorySearchGraph = false
      const url = "api/websites/page_distribution"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload["timestamp"]  = self.date.startDate
      // payload["timestamp"]  = '2022-02-02'
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url,payload).then(response => {
        self.loader3 = false
        self.pageDistributionData = response.body.data
        self.processSOVSOSGraph()
        self.processCategorySearchGraph()
        self.activecategorySearchGraph = true
      }, err => {
        self.loader3 = false
      });
    },
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      let self = this  
      self.cpuFilter = ''
      self.brandFilter = ''
      self.ratingExp = 'eq'
      self.ratingInput1 = ''
      self.ratingInput2 = ''
      if(localStorage.cpuFilter) delete localStorage.cpuFilter
      if(localStorage.brandFilter) delete localStorage.brandFilter
      if(localStorage.ratingExp) delete localStorage.ratingExp
      if(localStorage.ratingInput1) delete localStorage.ratingInput1
      if(localStorage.ratingInput2) delete localStorage.ratingInput2
      this.brandFilter = ''
      this.cpuFilter = ''
      $('#myTable').DataTable().destroy();
      if(localStorage.selected_website!=this.selected_website)
        delete localStorage['selected_product'];
      if(localStorage.selected_category!=this.device)
        delete localStorage['selected_product'];
      if(this.selected_website != 'all')
        localStorage.selected_website = this.selected_website
      localStorage.selected_category = this.device
      localStorage.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      this.showBrand = true
      this.showBrandHP = true
      this.isOEM = false
      this.labelMapper = {
        'brand': 'Brand',
        'processor_type': 'AMD Processor',
        // 'gpu_type': 'GPU'
      }
      if(this.oem_websites.includes(this.selected_website))
      {
        this.showBrand = false
        this.showBrandHP = false
        this.isOEM = true
        this.labelMapper = {
          'processor_type': 'AMD Processor',
        }
      }   
      this.sov()
      this.website_details()
      this.ryzenVsNonRyzen()
      this.getDailyData()
      this.getDailyDataOEM()
      this.getComData()
      this.getProducts()
      if(this.oem_websites.includes(this.selected_website))
        this.getWebsiteSOS()
    },
  	sov(){
      let self = this
      self.activeChart = false
      self.loader = true
      const url = "/api/websites/sov"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload["timestamp"]  = self.date.startDate
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }
  		this.$http.post(url, payload).then(response => {
        this.rows = response.body.data.sov
        this.sos_rows = response.body.data.sos
        self.loader = false
        self.$nextTick(function(){
          let xaxis = []
          let data1 = []
          let data2 = []
          let data3 = []
          let data4 = []
          let max1 = 0
          let max2 = 0
          let limit = 9
          let textCat = 'Page 1 Count: <b>' +self.rows[0].page_1_count + 
                    '</b><br/>Pages 1-3 Count: <b>'+self.rows[0].page_1_3_count+
                    '</b><br/>AMD '+ self.deviceMapper[self.device]  +' Count: <b>' +  (self.rows[0].page_all_system_count + self.rows[1].page_all_system_count) + '</b>'
          let textSch = 'Page 1 Count: <b>' + self.sos_rows[0].page_1_count + 
                        '</b><br/>Pages 1-3 Count: <b>'+self.sos_rows[0].page_1_3_count+
                        '</b><br/>AMD '+ self.deviceMapper[self.device]  +' Count: <b>' +  (self.sos_rows[0].page_all_system_count+self.sos_rows[1].page_all_system_count) + '</b>'
          if ((self.rows[0].page_all_system_count == 0 ) || (self.selected_website == 'all')) 
          {
            textCat = 'Page 1 Count: <b>' +self.rows[0].page_1_count + 
                    '</b><br/>Pages 1-3 Count: <b>'+self.rows[0].page_1_3_count + '</b>'
            textSch = 'Page 1 Count: <b>' + self.sos_rows[0].page_1_count + 
                        '</b><br/>Pages 1-3 Count: <b>'+self.sos_rows[0].page_1_3_count+ '</b>' 
            limit = 9
          }
          for(let [idx, dataset] of self.columns.slice(3,limit).entries()) 
          {

            if((dataset.field!='page_1_count') && (dataset.field!='page_all_count') && (dataset.field!='page_1_system_count') && (dataset.field!='page_all_system_count') && (dataset.field!='page_1_3_count')&& (dataset.field!='page_1_3_system_count'))
            {
              var d1 = Number(self.rows[0][dataset.field].toFixed())
              var d2 = Number(self.rows[1][dataset.field].toFixed())
              var d3 = Number(self.sos_rows[0][dataset.field].toFixed())
              var d4 = Number(self.sos_rows[1][dataset.field].toFixed())
              if(d1>=max1) max1 = d1
              if(d2>=max1) max1 = d2
              if(d3>=max2) max2 = d3
              if(d4>=max2) max2 = d4
              xaxis.push(dataset.label)
              data1.push(d1)
              data2.push(d2)
              data3.push(d3)
              data4.push(d4)
            }
          }  
         

          self.charts = 
            {
              credits: {
                enabled: false
              },
              chart: {
                type:'column',
                height:320,
                inverted:true
              },
              title: {
                text: ''
              },
              subtitle: {
                  align:'left',
                  text: textCat
              },
              yAxis: {
                  title: {
                      text: ''
                  },
                  max:max1 + 5
              },
               plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                        color:'black',
                        inside: false,
                        formatter:function(){
                          let mapper = {}
                          let d = this.series.userOptions.allData
                          mapper['Page 1 SOV'] =  d.page_1_system_count+ '/' + d.page_1_count
                          mapper['Pages 1-3 SOV'] =  d.page_1_3_system_count+ '/' + d.page_1_3_count
                          mapper['All Pages SOV'] = d.page_all_system_count+ '/' + d.page_all_count
                          if(mapper[this.key])
                            return this.point.y + '%'
                          else
                            return this.point.y 
                        }
                    }
                }
    },
              xAxis:{
                categories: xaxis,
                crosshair: true,
              },
              tooltip: {
                formatter: function() {
                  var mytooltip = this.points[0].key + '<br/>';
                  for(var i = 0;i<this.points.length;i++)
                  {
                    mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
                    mytooltip += this.points[i].series.name
                    mytooltip += ' : <b> ' + self.format(this.points[i].y);
                    if(this.points[0].key.indexOf('SOV')!=-1)
                      mytooltip += '%'
                    mytooltip += '</b><br/>'
                  }
                  return mytooltip;
                },
                shared: true
              },
              series: [ 
              {
                name: 'Entros',
                data:data1,
                color:'#3368fa8c',
                allData: self.rows[0] 
              }, 
              ]
            }

          self.charts_sos = 
            {
              credits: {
                enabled: false
              },
              chart: {
                type:'column',
                height:320,
                inverted:true
              },
              title: {
                text: ''
              },
              subtitle: {
                  align:'left',
                  text: textSch
              },

              yAxis: {
                  title: {
                      text: ''
                  },
                  max: max2 + 5
              },
               plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true,
                        color:'black',
                        formatter:function(){
                          let mapper = {}
                          let d = this.series.userOptions.allData
                          mapper['Page 1 SOV'] =  d.page_1_system_count+ '/' + d.page_1_count
                          mapper['Pages 1-3 SOV'] =  d.page_1_3_system_count+ '/' + d.page_1_3_count
                          mapper['All Pages SOV'] = d.page_all_system_count+ '/' + d.page_all_count
                          if(mapper[this.key])
                            return this.point.y + '%'
                          else
                            return this.point.y 
                        }
                    }
                }
              },
              xAxis:{
                categories: xaxis,
                crosshair: true,
              },
              tooltip: {
                formatter: function() {
                  var mytooltip = this.points[0].key + '<br/>';
                  for(var i = 0;i<this.points.length;i++)
                  {
                    mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
                    mytooltip += this.points[i].series.name
                    mytooltip += ' : <b> ' + self.format(this.points[i].y);
                    if(this.points[0].key.indexOf('SOV')!=-1)
                      mytooltip += '%'
                    mytooltip += '</b><br/>'
                  }
                  return mytooltip;
                },
                shared: true
              },
              series: [ 
              {
                name:self.sos_rows[0]['sub_brand'],
                data:data3,
                color:'#3368fa8c',
                allData: self.sos_rows[0] 
              }, 
              { 
                name:self.sos_rows[1]['sub_brand'],
                data:data4,
                color:'#833c808c',
                allData: self.sos_rows[1] 
              } ]
            }
          $('#myTable').DataTable();
          self.activeChart = true
        })
         
      }, err => {
        self.loader = false
      });
  	},
    format(v)
    {
      return this.$options.filters.format(v)
    }, 
    countIt(listingType,dataset){
      let self = this
      for(let [i, d] of Object.entries(this.labelMapper))
      {
        if(dataset[i]=="" || dataset[i]==" " ) dataset[i] = "N/A"
        if(dataset[i].indexOf('amd')!=-1) dataset[i] = dataset[i].replace('amd','AMD')
        if(dataset[i].indexOf('hp')!=-1) dataset[i] = dataset[i].replace('hp','HP')
        if (isNaN(self[listingType][i][dataset[i]]))
          self[listingType][i][dataset[i]] = 1
        else  
          self[listingType][i][dataset[i]]++
      } 
    },
    getColorShades(baseColor){
      if(this.index[baseColor] > this.colorShades[baseColor].length-1)
      {
        this.index[baseColor] = 0
      }
      let c = this.colorShades[baseColor][this.index[baseColor]]
      this.index[baseColor]++
      return c
    },
    generatePieCharts(listingType,chartKey){
      let self = this
      for(let [idx, dataset] of Object.entries(self[listingType])) 
      {
        let seriesData = []
        let finalSeriesData = []
        let color_codes = ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4']
        let color_index = 0
        let color_index1 = 0
        let color_index3 = 0
        for(let [idx2, dataset2] of Object.entries(dataset))
        {
          let obj = {}
          let color = {}
          let whichCpu = ''
          let whichGpu = ''
          if (idx=='brand') 
          {
            color[idx2] = color_codes[color_index3]
            color_index3 = color_index3 + 1
          } 
          else if (idx=='processor_type') 
          {
            if ((idx2.indexOf('amd')!=-1)||(idx2.indexOf('AMD')!=-1))
            {
              color[idx2] = color_codes[color_index]
              whichCpu = 'amd' 
            }
            else if ((idx2.indexOf('intel')!=-1) || (idx2.indexOf('pentium')!=-1) || (idx2.indexOf('core')!=-1) )
              {
                whichCpu = 'intel' 
                color[idx2] = color_codes[color_index]
              }
            else
            {
              whichCpu = 'N/A' 
            }
            color_index = color_index + 1  
          }
          else if (idx=='gpu_type') 
          {
            if ((idx2.indexOf('amd')!=-1)||(idx2.indexOf('radeon')!=-1) ) 
            {
              whichGpu = 'amd'
              color[idx2] = color_codes[color_index1]
            }
            else if ((idx2.indexOf('intel')!=-1) || (idx2.indexOf('uhd')!=-1) || (idx2.indexOf('iris')!=-1) || (idx2.indexOf('integrated')!=-1) )
            {
              whichGpu = 'intel'
              color[idx2] = color_codes[color_index1]
            }
            else if ((idx2.indexOf('nvidia')!=-1) || (idx2.indexOf('geforce')!=-1) )
            {
              whichGpu = 'nvidia'
              color[idx2] = color_codes[color_index1]
            }  
            else 
            {
              whichGpu = 'N/A'
            }
            color_index1 = color_index1 + 1
          }
          if (idx2 =='N/A')
            color[idx2] = '#b9c6de'
         
          obj['name'] = idx2 
          obj['y'] = dataset2
          obj['cpu'] = whichCpu
          obj['gpu'] = whichGpu
          if(color[idx2])
            obj['color'] = color[idx2]
          seriesData.push(obj)    
        } 
        if (idx=='brand') 
        {
          finalSeriesData = seriesData
        }
        else if (idx=='processor_type') 
        {
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='N/A') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='amd') finalSeriesData.push(dataset)
          }  
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.cpu=='intel') finalSeriesData.push(dataset)
          } 
          
        }
        else if (idx=='gpu_type') 
        {
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='N/A') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='amd') finalSeriesData.push(dataset)
          }  
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='intel') finalSeriesData.push(dataset)
          } 
          for(let [idx, dataset] of seriesData.entries()) 
          {
             if(dataset.gpu=='nvidia') finalSeriesData.push(dataset)
          } 
         
        }
        self[chartKey][idx] = {
          chart: {
            margin: [80,0,35,0],
            padding:[0,0,0,0]
           
          },
          title: {  
              text:   self.deviceMapper[self.device]  +' Category Page ('+ self.selectedPage +') Distribution by ' + self.labelMapper[idx],
              verticalAlign:'bottom',
              style:{fontSize:13}
          },
          credits: {
            enabled: false
          },
          accessibility: {
            point: {
                valueSuffix: '%'
            }
          },
          tooltip: {
            formatter(){
              var mytooltip = ''
              mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
              mytooltip += this.point.name
              mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
              mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
              return mytooltip;             
            },
          },
          plotOptions: {
              series: {
                  borderWidth: 0,
              },
              pie: {
                  dataLabels: {
                    enabled: true,
                    useHTML: true,
                    formatter: function() { 
                      self.pieTotal = this.point.total 
                     
                      return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                    },
                    distance: -13,
                    style: {
                      fontSize: 11,
                    }  
                  },
                  showInLegend: true,
                  size: '100%'
              }
          },
          legend:{
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            itemStyle: {
              fontSize: 11,
              fontWeight: 1
            },
            maxHeight: 65, 
          },  
          series: [{  
            type: 'pie',
            data: finalSeriesData
          }]
        } 
        setTimeout(function(){
          self.activePie = true
        },50)
      }
    },
    readyPieCharts(){
      let self = this
      self.clearPieDataset()
      for(let [idx, dataset] of this.rows_details.entries()) 
      {
        if ((self.selectedPage == 1) && (dataset.page!=1)) continue
        if (dataset.processor == 'amd')
        {
          if(self.amdCPUFilter == 'all')
          {
            self.countIt('countAMD',dataset)
          }
          else if (self.amdCPUFilter == 'ryzen')
          {
            if(dataset.processor_type.indexOf('ryzen')!=-1)
              self.countIt('countAMD',dataset)
            else
              continue
         }
         else
         {
           if(dataset.processor_type.indexOf('ryzen')==-1)
              self.countIt('countAMD',dataset)
            else
              continue
         }
        }
      }
      self.generatePieCharts('countAMD','pieChartAMD') 
    },
    createPie(){
      let self = this
      let color_codes = ['#78b2fb','#cefb78','#fb7878','#b0e1ff','#78eefb','#91ce8e','#59cdfb','#fbd378','#c139a4']
      let color_index_total = 0
      let color_index = 0
      let color = {}
      let color_total = {}
      let total = 0
      let seriesData = []
      let totalData = self.total_processor_data
      let alltotal = 0
      for(let [idx, dataset] of totalData.entries())
      {
        color_total[dataset.name] = color_codes[color_index_total]
        color_index_total = color_index_total + 1
        dataset.color = color_total[dataset.name]
        alltotal = alltotal + dataset.y
      }
      self['pieChartAMDTotal'] = {
            chart: {
              margin: [80,0,35,0],
              padding:[0,0,0,0]
             
            },
            title: {  
                text:  self.deviceMapper[self.device]  +' Category Page ('+ self.selectedPage +') Distribution by Brand',
                verticalAlign:'bottom',
                style:{fontSize:13}
            },
            credits: {
              enabled: false
            },
            accessibility: {
              point: {
                  valueSuffix: '%'
              }
            },
            tooltip: {
              formatter(){
                var mytooltip = ''
                mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
                mytooltip += this.point.name
                mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
                mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
                return mytooltip;             
              },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                },
                pie: {
                    dataLabels: {
                      enabled: true,
                      useHTML: true,
                      formatter: function() { 
                        self.pieTotalAll = this.point.total 
                       
                        return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                      },
                      distance: -13,
                      style: {
                        fontSize: 11,
                      }  
                    },
                    showInLegend: true,
                    size: '100%'
                }
            },
            legend:{
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'top',
              itemStyle: {
                fontSize: 11,
                fontWeight: 1
              },
              maxHeight: 65, 
            },  
            series: [{  
              type: 'pie',
              data: totalData
            }]
          }
      for(const property in self.labelMapper)
      {
        if(property=='brand')
          seriesData = self.pie_brand
        else if(property=='processor_type')
          seriesData = self.pie_cpu
        for(let [idx, dataset] of seriesData.entries())
        {
          color[dataset.name] = color_codes[color_index]
          color_index = color_index + 1
          dataset.color = color[dataset.name]
          total = total + dataset.y
        }
        for(let [idx, dataset] of seriesData.entries())
        {
          dataset.total = total
        }
        self.pieSeriesData = seriesData
        self['pieChartAMD'][property] = {
            chart: {
              margin: [80,0,35,0],
              padding:[0,0,0,0]
             
            },
            title: {  
                text:  self.deviceMapper[self.device]  +' Category Page ('+ self.selectedPage +') Distribution by ' + self.labelMapper[property],
                verticalAlign:'bottom',
                style:{fontSize:13}
            },
            credits: {
              enabled: false
            },
            accessibility: {
              point: {
                  valueSuffix: '%'
              }
            },
            tooltip: {
              formatter(){
                var mytooltip = ''
                mytooltip += '<span style="font-size:22px;color:' + this.point.color + '">\u25CF</span> '
                mytooltip += this.point.name
                mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage.toFixed())  + '%)</b> <br/>'
                mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
                return mytooltip;             
              },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                },
                pie: {
                    dataLabels: {
                      enabled: true,
                      useHTML: true,
                      formatter: function() { 
                        self.pieTotal = this.point.total 
                       
                        return  '<span style="color:black;font-size:11px;font-weight:normal;">' +self.format(this.point.percentage.toFixed()) + '%</span>'
                      },
                      distance: -13,
                      style: {
                        fontSize: 11,
                      }  
                    },
                    showInLegend: true,
                    size: '100%'
                }
            },
            legend:{
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'top',
              itemStyle: {
                fontSize: 11,
                fontWeight: 1
              },
              maxHeight: 65, 
            },  
            series: [{  
              type: 'pie',
              data: seriesData
            }]
          }
          setTimeout(function(){
            self.activePie = true
          },50)
        }
    },
    readyPie(){
      let self = this
      let filter_data = []
      self.pie_brand = []
      self.pie_cpu = []
      self.total_processor_data = []
      this.brand_list = self.pie_data[self.amdCPUFilter][self.selectedPage]['brand_list']
      this.cpu_list = self.pie_data[self.amdCPUFilter][self.selectedPage]['cpu_list']
      this.total_processor_list = self.total_pie_data[self.selectedPage]['data']
      for(let [idx, dataset] of this.brand_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        if(di['name'].indexOf('hp')!=-1) di['name'] = di['name'].replace('hp','HP')
        self.pie_brand.push(di)
      }
      for(let [idx, dataset] of this.cpu_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        if(di['name'].indexOf('hp')!=-1) di['name'] = di['name'].replace('hp','HP')
        self.pie_cpu.push(di)
      }
      for(let [idx, dataset] of this.total_processor_list.entries())
      {
        let di = {}
        di['name'] = dataset['key']
        di['y'] = dataset['doc_count']
        if(di['name']=="")
          di['name'] = "N/A"
        if(di['name'].indexOf('amd')!=-1) di['name'] = di['name'].replace('amd','AMD')
        self.total_processor_data.push(di)
      }
      self.createPie()
    },
    clearPieDataset(){
      let self = this
      for(let [i, d] of Object.entries(this.labelMapper))
      {
        self.countAMD[i] = {}
        self.pieChartAMD[i] = {}
      }
    },
 
    website_details(){
      let self = this
      // self.loader = true
      self.rows_details = []
      self.activePie = false
      // const url = "/api/websites/details"
      const url = "/api/websites/website_metrics"
      let page = null
      if(self.selectedPage == 1)
        page=1
      let payload = {}
      payload["website"] = []
      payload["timestamp"]  = self.date.startDate
      // payload["timestamp"]  = '2022-02-02'
      payload["page"] = page
      payload["processor"] = this.amdCPUFilter
      payload["item_category"] = self.device
      if (self.selected_website == 'all')
      {
        for(let [idx, dataset] of Object.entries(self.websitesUrls))
        {
          if(!self.oem_websites.includes(idx)) payload["website"].push(idx)
        }
      }
      else
      {
        payload["website"].push(self.selected_website)
      }  
      this.$http.post(url, payload).then(response => {
        // this.brand_list = response.body.data.brand_list
        // this.cpu_list = response.body.data.cpu_list
        this.pie_data = response.body.data
        this.total_pie_data = response.body.total_data
        // self.loader = false
        self.readyPie()
        // self.readyPieCharts()
      }, err => {
        self.loader = false
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
  
  }
}

</script>

<style scoped>
.sovshowdetails{
    float: right;
    border-radius: 0;
    font-size: 12px!important;
    padding: 6px;
    width: max-content!important;
    cursor: pointer;
    margin: 4px 5px 0px 0;
    background: #8a87e8;
    height: fit-content;
}
.selectedProduct
{
  background: #8e8d8d!important;
  color: White!important;
}
.eachProduct:hover
{
    background: #d4d4d4;
}
.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
 
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color:#4e4e4e;
    margin-bottom: 0;
  
}
.space-between-header h4  {
  color:#4e4e4e;
    margin-bottom: 0;
    
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycol
{
  padding-right:15px!important;
  padding-left:15px!important;
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:nth-child(5)
{
  padding-left:2px;
  padding-right:2px
}
.mycols:nth-child(4)
{
  padding-left:15px!important
}
.mycols:nth-child(3)
{
  padding-right:15px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle
{
      color: #ffffff;
    background-color: #8a87e8;
    border-color: #8a87e8;
    height:30px;
    border-radius:0
}
.btn-outline-secondary
{
  height:30px;
   border-radius:0;
   line-height: 17px;
   background:white
}
.sovdetails{
      float: right;
    height: 30px;
    margin: 0;
    border-radius: 0;
    font-size: 15px;
    padding: 7px;
    width: max-content;
    cursor: pointer;
    margin-left: 4px;
}
select option {text-transform:capitalize}
</style>
